import styles from '../TravelExpensesOverlayController.module.scss';

import { memo } from 'react';

import { Panel } from '../../../components';

import { AdditionalMealExpenses } from './AdditionalMealExpenses';
import { Assignment } from './Assignment';
import { GeneralInfo } from './GeneralInfo';
import { TravelReceiptsTable } from './TravelReceiptsTable';

export const General = memo(function General() {
  return (
    <Panel className={styles.panel}>
      <GeneralInfo />
      <Assignment />
      <AdditionalMealExpenses />
      <TravelReceiptsTable />
    </Panel>
  );
});
